import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useSelector } from 'react-redux'
import estilos from './AsociadosComponent.module.css'
import { reAsignarAsociado } from '../../../redux/DucksUnidadInspeccion/ZonasDuck';
import { useDispatch } from 'react-redux';

function DesvincularAsociadoDeLocalidadComponent(props) {

	const dispatch = useDispatch()
	const zonaProveniente = props.zona
	const localidadProveniente = props.localidad
	const zonas = useSelector(store => store.Zonas.zonas);
	const [inicialStateFormik, setInicialStateFormik] = useState({
			localidad: 0, zona: 0
		}
	)
	const [zonaSelected, setZonaSelected] = React.useState({id: undefined})
    const [subLocalidades, setSublocalidades] = React.useState([])

	const handleReset = (resetForm) => {
		resetForm()
	}

	const handleOnChangue = (event) => {

        if(event.target.name == 'localidad'){
            const idLocalidad = event.target.value
            const localidadx = zonas.find(zona => zona.id == zonaSelected.id)
            const localidadDest = localidadx.localidades.find(loc => loc.id == idLocalidad)
            if(localidadDest.subLocalidades != undefined) {
                setSublocalidades(localidadDest.subLocalidades)
            }else{
                setSublocalidades([])
            }
        }

        if(event.target.name == 'zona' && event.target.value == 0) {
            setZonaSelected({id : undefined})
            setSublocalidades([])
			setInicialStateFormik({localidad: 0, zona: 0})
        }else {
            if(event.target.name == 'zona') {
				setZonaSelected({id : undefined})
            	setSublocalidades([])
				setInicialStateFormik({localidad: 0, zona: 0})
                const idZona = event.target.value
                const zonax = zonas.find(zona => zona.id == idZona)
                setZonaSelected(zonax)
            }
        }
    }

	return (
			<div>
					<h3>¿Estás seguro de Re Asignar esta instalacion del asociado <strong>({props.asociado.nombreAsociado})</strong> de la localidad <strong>({props.localidad.nombre})?</strong></h3>

					<h4>Mover a localidad:</h4><br />
					<div className='container'>
						<Formik 
								initialValues={inicialStateFormik}
								validate={values => {
									const errors = {};
									if(values.zona == 0) {
											errors.zona = 'Seleccione una zona'
									}
			
									if(values.localidad == 0) {
											errors.localidad = 'Seleccione una localidad'
									}
									return errors;    
									}
								} 

								onSubmit={(values, { setSubmitting })=> {
                                    console.log(values)
									setSubmitting(false);
									dispatch(reAsignarAsociado({
										zonaProveniente: zonaProveniente.id,
										localidadProveniente: localidadProveniente.id,
										asociado: props.asociado,
										localidadDestino: values.localidad,
										zonaDestino: values.zona
									}))
									props.onClose();
								}}>

								{({ isSubmitting, resetForm }) => (
								<Form onChange={handleOnChangue}>
									<label htmlFor="zona">Zona:</label><br />
									<Field as="select" className='form-control' name="zona">
										{
											<option key={0} value={0}>Seleccione zona de destino</option>
										}
										{
											zonas.map((zona, index) => (
												<option key={index} value={zona.id}>{zona.nombreZona}</option>
											))
										}
									</Field>
									<ErrorMessage name="zona" component="div" className={`${estilos.error}`} />
									{
										zonaSelected.id !== undefined ? (
										<>
											<label htmlFor="localidad">Localidades:</label><br />
											<Field as="select" className='form-control' name="localidad">
												{
													<option key={0} value={0}>Seleccione zona de destino</option>
												}
												{
													zonaSelected.localidades.map((localidad, index) => (
														<option key={localidad.id} value={localidad.id} >{localidad.nombre}</option>
													))
												}
											</Field>
											<ErrorMessage name="localidad" component="div" className={`${estilos.error}`} />
                                            {
                                                subLocalidades.length !== 0 ? (
                                                <>
                                                    <label htmlFor="subLocalidad">Sub Localidades:</label><br />
                                                    <Field as="select" className='form-control' name="subLocalidad">
                                                        {
                                                            <option key={0} value={0}>Seleccione Sub Localidad de destino</option>
                                                        }
                                                        {
                                                            subLocalidades.map((sublocalidad, index) => (
                                                                <option key={sublocalidad.id} value={sublocalidad.id} >{sublocalidad.nombre}</option>
                                                            ))
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="subLocalidad" component="div" className={`${estilos.error}`} />
                                                </>
                                                ): (
                                                    <div>

                                                    </div>
                                                )
                                            }

											<div className='text-center mt-5'>
												<button type="submit" disabled={isSubmitting}
													className='btn btn-lg btn-success'>
													Guardar cambios
												</button>
											</div>
										</>
										): (
											<div>

											</div>
										)
									}
                                    
								</Form>
								)}
						</Formik>
					</div>
			</div>
	)
}

export default DesvincularAsociadoDeLocalidadComponent